import { useState, useEffect } from "react";
import Button from "../../UI/Buttons/Button";
import Variant from "./Variant";
import "./Variant.scss";
import ReactHtmlParser from 'html-react-parser';
import { useParams } from 'react-router-dom';
const Variants = (props) => {
    const { productVariants, setStyle, addToBasket, isMultiVariant, fid } = props;
    // FIX: Initialize as empty object, not array — varQuantity is used as { [variantId]: count }
    const [varQuantity, setVarQuantity] = useState({});
    const [selectedVariant, setSelectedVariant] = useState(null);

    // Pre-select the first variant for pill style
    useEffect(() => {
        if (setStyle === "pill" && productVariants?.length > 0 && !selectedVariant) {
            setSelectedVariant(productVariants[0].productvariantid);
        }
    }, [productVariants, setStyle]);

    // Initialize qty-dropdown to 1 for card/pill multi-variant (not list which uses +/-)
    useEffect(() => {
        if (isMultiVariant && setStyle !== "list" && productVariants?.length > 0) {
            setVarQuantity(prev => {
                const hasValues = Object.values(prev).some(v => v > 0);
                if (hasValues) return prev;
                const initial = {};
                productVariants.forEach(v => { initial[v.productvariantid] = 1; });
                return initial;
            });
        }
    }, [isMultiVariant, setStyle]);
   
    console.log('fid: ', fid)

    const selectVariant = (id) => {
        setSelectedVariant(id);
    };

    const subscribePill = () => {
        if (selectedVariant) {
            addToBasket(selectedVariant);
            props?.checkout(fid, true);
        }
    };

    const incrementQuantity = (id) => {
        setVarQuantity((prevCounters) => ({
            ...prevCounters,
            [id]: (prevCounters[id] || 0) + 1,  
        }));
        addToBasket(id)
 
    };
 
    const decreaseQuantity = (id) => { 
        const currentQty = varQuantity[id] || 0;
        if (currentQty > 0) {
            setVarQuantity((prevCounters) => ({
                ...prevCounters,
                [id]: currentQty - 1, 
            }));
            props?.reduceFromBasket(id, 1);
        }
    };

    const setQuantityForVariant = (id, newQuantity) => {
        const currentQty = varQuantity[id] || 0;
        setVarQuantity((prev) => ({ ...prev, [id]: newQuantity }));
        
        if (newQuantity > currentQty) {
            // Need to add the difference
            addToBasket(id, newQuantity - currentQty);
        } else if (newQuantity < currentQty) {
            // Need to reduce the difference
            props?.reduceFromBasket(id, currentQty - newQuantity);
        }
    };

    // FIX: Was setting varQuantity to the number 1, which destroyed the entire quantity state object.
    // Now correctly sets only the selected variant's quantity to 1.
    const oneproductbuy = (id) => {
        const qty = varQuantity[id] || 1;
        setVarQuantity((prev) => ({ ...prev, [id]: qty }));
        addToBasket(id, qty)
        props?.checkout(fid, true)
    }
    return (
        <>
            <div className="item-wrapper">
                {/* Block style always uses row layout for multi-column grid.
                    Pill style stacks vertically. List style stacks vertically. */}
                <div className={`item-container ${setStyle !== "pill" && setStyle !== "list" ? "flex-direction-row" : ""}`}>
                    {productVariants.map((item, index) => 
                        <>
                            <Variant
                                key={index}
                                variant={item.productvariantid}
                                price={item?.price}
                                description={item?.productvariantname}
                                setStyle={setStyle}
                                incrementQuantity={incrementQuantity}
                                decreaseQuantity={decreaseQuantity}
                                oneproductbuy={oneproductbuy}
                                setQuantityForVariant={setQuantityForVariant}
                                varQuantity={varQuantity[item.productvariantid] || 0}
                                addToBasket={props?.addToBasket} 
                                highlighted={item.productvariantid == 2656 ? true : false}
                                emphasis={item.productvariantid == 2656 ? true : false}
                                badge={item.productvariantid == 2656 && "Today only"}
                                isMultiVariant={setStyle === "list" ? isMultiVariant : false}
                                isMultiVariantDropdown={setStyle !== "list" && isMultiVariant}
                                selected={selectedVariant === item.productvariantid}
                                selectVariant={selectVariant}
                            />
                        </>
                    )}

                </div>
                {/* Pill style has its own shared Subscribe button outside the cards */}
                {setStyle === "pill" && (
                    <div className="pill-subscribe-action">
                        <button className="subscribe-btn" onClick={subscribePill} disabled={!selectedVariant}>Subscribe</button>
                    </div>
                )}
        </div>
 
        </>
    )

}

export default Variants;